import React from "react";
import Button from "../../../independent/Button";
import {selectShouldCloseAllOnConfirm} from "../../../../redux/modal-slice/modalSlice";
import {useSelector} from "react-redux";

const Confirm = ({title, closeSubModal, message, callback, closeModal}) => {
  const shouldCloseAllOnConfirm = useSelector(selectShouldCloseAllOnConfirm);

  const handleConfirm = () => {
    if (callback) {
      callback();
    }

    closeSubModal();

    if (shouldCloseAllOnConfirm) {
      closeModal();
    }
  };


  return (
    <div>
      <div className={"modal-header"}>
        <h2>{title}</h2>
        <button type="button" className="modal-close" onClick={closeSubModal}>
          close
        </button>
      </div>
      <div className={"modal-body"}>
        <span>{message}</span>
      </div>
      <div className={"modal-footer"}>
        <div className={"delete-history-buttons"}>
          <Button name={"CONFIRM"}
                  block={true}
                  confirm={true}
                  onClick={handleConfirm}
          />
          <Button name={"CANCEL"}
                  block={true}
                  onClick={closeSubModal}
          />
        </div>
      </div>
    </div>
  )
}

export default Confirm;
